'use client';

import Image from 'next/image';
import { twMerge } from 'tailwind-merge';

import { Link, LinkProps } from '@/components/Link';
import { useLayout } from '@/context/layout-context';
import { Paths } from '@/utils/paths';

export type LogoProps = Omit<LinkProps, 'href'>;

export function Logo({ className, ...props }: LogoProps) {
  const { content } = useLayout();

  const { zmyle, zmyleLogoUrl } = content?.topbar;

  return (
    <Link
      href={Paths.HOME}
      className={twMerge('absolute top-6 left-6 z-[1]', className)}
      {...props}
    >
      <Image
        className="brightness-0 invert"
        src={zmyleLogoUrl}
        alt={zmyle}
        height={40}
        width={150}
        quality={30}
        priority
        sizes="150px"
      />
    </Link>
  );
}
